import useCredentialTypeDropdown from './UseCredentialTypeDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const CredentialTypeDropdown = ({ label, name, value, error, message, onChange }) => {
  const { credentialTypeState } = useCredentialTypeDropdown();

  return credentialTypeState.message
    ? <span className={global.LoadingMsg}>{credentialTypeState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={credentialTypeState.dataAsOptionsWithNames}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={credentialTypeState.isArrayLoading}
      />
    );
};

export default CredentialTypeDropdown;